import { Grid } from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import Slider from "react-slick";
import BusClaimApiService from "../../adapters/xhr/BusClaimApiService";
import BusStationApiService from "../../adapters/xhr/BusStationApiService";
import TrainStationApiService from "../../adapters/xhr/TrainStationApiService";
import { AllowedFileExtensions, SliderSettings, TotalCostSEKMax, TransportationMethod } from "../../Constant";
import MyContext from "../../contexts/MyContext";
import Logopng from "../../static/ST_Symbol_ID.png";
import Logosvg from "../../static/ST_Symbol_ID.svg";
import Logo from "../../static/STT_Logo_2rad_Grön.png";
import { formatDate, formatTime } from "../../Utils";
// todo: should be removed after refactor scss
import "./BusPublicPage.scss";
import { Slide1 } from "./slides/Slide1";
import { Slide2 } from "./slides/Slide2";
import { Slide3 } from "./slides/Slide3";
import { Slide4 } from "./slides/Slide4";
import { Slide5 } from "./slides/Slide5";
import { Slide6 } from "./slides/Slide6";

export const BusPublicPage = (props) => {
  //   const sliderRef = useRef(null);
  let sliderRef = React.createRef();
  const myContext = useContext(MyContext);

  const fetchTrainStations = useCallback(async () => {
    let response = await BusStationApiService.getTrainStations();
    if (response.isSuccess) {
      myContext.changeTrainStations(response.data);
    }
  }, []);

  const getTotalCostMax = useCallback(async () => {
    let response = await BusClaimApiService.getTotalCostMax();
    if (response.isSuccess && response.data) myContext.changeTotalCostSEKMax(response.data);
    else myContext.changeTotalCostSEKMax(TotalCostSEKMax);
  }, []);

  const getAllowedFileExtension = useCallback(async () => {
    let response = await BusClaimApiService.getAllowedFileExtension();
    if (response.isSuccess && response.data) myContext.changeAllowFileUploadExtension(response.data);
    else myContext.changeAllowFileUploadExtension(AllowedFileExtensions.map((item) => item.key));
  }, []);

  const fetchStops = useCallback(async () => {
    let response = await BusStationApiService.getAll();
    if (response.isSuccess) {
      myContext.changeStops(response.data);
    }
  }, []);

  const fetchLines = useCallback(async () => {
    let response = await BusStationApiService.getLines();
    if (response.isSuccess) {
      myContext.changeLines(response.data);
    }
  }, []);

  useEffect(() => {
    document.title = "Sörmlandstrafiken - EVF";
    // append link tag to document head
    document.head.appendChild(Object.assign(document.createElement("link"), { rel: "icon", type: "image/png", href: Logopng }));
    document.head.appendChild(Object.assign(document.createElement("link"), { rel: "icon", type: "image/svg+xml", href: Logosvg }));
  }, []);

  useEffect(() => {
    getTotalCostMax();
    getAllowedFileExtension();
    if (!myContext.trainStations || myContext.trainStations.length === 0) fetchTrainStations();
    if (!myContext.stops || myContext.stops.length === 0) fetchStops();
    if (!myContext.lines || myContext.lines.length === 0) fetchLines();
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  const fetchTrainDepartureTimeList = async () => {
    let response = await TrainStationApiService.getDepartureTimeList(myContext.departureStation.code, myContext.arrivalStation.code, null, formatDate(myContext.departureDate));
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  const fetchBusDepartureTimeList = async () => {
    let response = await BusStationApiService.getDepartureTimeList(myContext.departureStation.code, myContext.arrivalStation.code, myContext.line.shortName, formatDate(myContext.departureDate));
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  useEffect(() => {
    if (myContext.departureDate && myContext.departureStation && myContext.arrivalStation && !myContext.departureTime) {
      if (myContext.transportationMethod == TransportationMethod.TRAIN) {
        fetchTrainDepartureTimeList();
        myContext.changeDepartureTime(null);
      }
      if (myContext.transportationMethod === TransportationMethod.BUS && myContext.line) {
        fetchBusDepartureTimeList();
        myContext.changeDepartureTime(null);
      }
    }
  }, [myContext.departureDate, myContext.departureStation, myContext.arrivalStation]);

  const setActiveSlide = (index) => {
    myContext.changeActiveSlide(index);
  };

  const fetchStopsOnLine = async () => {
    let response = await BusStationApiService.getAllStopsOnLine(myContext.line.shortName);
    if (response?.isSuccess) {
      myContext.changeStops(response.data);
      myContext.changeDepartureStation("");
      myContext.changeArrivalStation("");
    }
  };

  useEffect(() => {
    myContext.changeDepartureStation("");
    myContext.changeArrivalStation("");
    myContext.changeLine("");
    myContext.changeDepartureDate(null);
    myContext.changeDepartureTimeOptions(null);
    myContext.changeDepartureTime(null);
  }, [myContext.transportationMethod]);

  useEffect(() => {
    if (myContext.line) fetchStopsOnLine();
  }, [myContext.line]);

  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="bus page container custom padding top-2 bottom-2 left-0 right-0" justifyContent="center">
          <Grid item>
            <div hidden={context.activeSlide !== 0}>
              <img src={Logo} className="logo" title="Logo" alt="Logo" style={{ width: "7rem" }} />
            </div>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => setActiveSlide(next)}>
              <Slide1 />
              <Slide2 />
              <Slide3 />
              <Slide4 />
              <Slide5 />
              <Slide6 />
            </Slider>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
